import { useEffect, useState } from 'react';
import HeaderRoutesWithUnderlining from '../HeaderRoutes/HeaderRoutesWithUnderlining';

export const headerLinks = [
  {
    label: 'Neris Report Form',
    link: '/firehouse/neris-settings',
  },
  // {
  //   label: 'Station & Units Settings',
  //   link: '/firehouse/neris-settings/station-and-station-units',
  // },
  {
    label: 'Neris Types',
    link: '/firehouse/neris-settings/groups-and-types',
  },
];

const NerisSettingsNav = () => {
  const [step, setStep] = useState();

  useEffect(() => {
    let i = headerLinks.findIndex((x) => {
      return x.link === window.location.pathname;
    });

    setStep(i);
  }, []);

  return (
    <div className="d-flex">
      {step !== undefined && (
        <HeaderRoutesWithUnderlining step={step} steps={headerLinks} />
      )}
    </div>
  );
};

export default NerisSettingsNav;
